import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import EditableIssue from "./EditableIssue";

const EditableIssueList = ({
  issues,
  onUpdateIssue,
  onDeleteIssue,
  isLoading,
  environment,
}) => {
  const [showNewIssueForm, setShowNewIssueForm] = useState(false);
  const [allExpanded, setAllExpanded] = useState(true); // All issues in edit mode by default
  console.log("EDITABLE ISSUE LIST issues", issues);
  // New empty issue template
  const emptyIssue = {
    id: "",
    title: "",
    description: "",
    severity: "medium",
    status: "open",
    regions: [],
    platforms: [],
    issue_rows: [],
  };

  const handleAddNewIssue = () => {
    setShowNewIssueForm(true);
  };

  const handleNewIssueSubmit = (newIssue) => {
    onUpdateIssue(newIssue);
    setShowNewIssueForm(false);
  };

  const handleCancelNewIssue = () => {
    setShowNewIssueForm(false);
  };

  // Button to add new issue
  const AddNewIssueButton = () => (
    <div className="flex justify-end mb-4">
      <button
        onClick={handleAddNewIssue}
        className="px-4 py-2 text-body-xs font-semibold bg-button-primary text-white rounded-xl hover:bg-button-primary-hover transition-colors"
      >
        + Add New Finding
      </button>
    </div>
  );

  if (isLoading) {
    return (
      <div className="space-y-4">
        {[1, 2, 3].map((index) => (
          <div
            key={index}
            className="bg-white rounded-2xl border border-border-subtle p-4 animate-pulse"
          >
            <div className="flex justify-between">
              <div className="w-3/4">
                <div className="h-5 bg-surface-neutral-subtle rounded w-1/2 mb-2"></div>
                <div className="h-4 bg-surface-neutral rounded w-1/4 mb-4"></div>
                <div className="h-4 bg-surface-neutral rounded w-full"></div>
              </div>
              <div className="w-1/6">
                <div className="h-5 bg-surface-neutral-subtle rounded w-full"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  // Display form when no issues or when add button is clicked
  if (showNewIssueForm) {
    return (
      <>
        <AddNewIssueButton />
        <EditableIssue
          issue={emptyIssue}
          onUpdate={handleNewIssueSubmit}
          onDelete={handleCancelNewIssue}
          startEditing={true}
        />
        {issues && issues.length > 0 && (
          <div className="space-y-4 mt-6">
            <div className="flex justify-between items-center pb-2 border-b border-border-subtle">
              <h3 className="text-body-lg font-semibold text-text-primary">
                Existing Findings ({issues.length})
              </h3>
              <button
                onClick={() => setAllExpanded(!allExpanded)}
                className="flex items-center text-body-xs text-text-tertiary hover:text-text-secondary focus:outline-none transition-colors"
                title={
                  allExpanded
                    ? "Switch all to view mode"
                    : "Switch all to edit mode"
                }
              >
                {allExpanded ? (
                  <>
                    <span className="mr-1">View All</span>
                    <FaChevronUp className="w-3 h-3" />
                  </>
                ) : (
                  <>
                    <span className="mr-1">Edit All</span>
                    <FaChevronDown className="w-3 h-3" />
                  </>
                )}
              </button>
            </div>

            {issues.map((issue) => (
              <EditableIssue
                key={issue.id}
                issue={issue}
                onUpdate={onUpdateIssue}
                onDelete={onDeleteIssue}
                forceEditMode={allExpanded}
              />
            ))}
          </div>
        )}
      </>
    );
  }

  if (!issues || issues.length === 0) {
    return (
      <div>
        <AddNewIssueButton />
        <div className="bg-white rounded-2xl border border-border-subtle p-8 text-center">
          <p className="text-body-sm text-text-secondary">No findings for this agent.</p>
          <p className="text-body-xs text-text-tertiary mt-2">
            Click the button above to add a new finding.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <AddNewIssueButton />
      <div className="space-y-4">
        <div className="flex justify-between items-center pb-2 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">
            Findings ({issues.length})
          </h3>
          <button
            onClick={() => setAllExpanded(!allExpanded)}
            className="flex items-center text-sm text-gray-500 hover:text-gray-700 focus:outline-none"
            title={
              allExpanded
                ? "Switch all to view mode"
                : "Switch all to edit mode"
            }
          >
            {allExpanded ? (
              <>
                <span className="mr-1">View All</span>
                <FaChevronUp className="w-3 h-3" />
              </>
            ) : (
              <>
                <span className="mr-1">Edit All</span>
                <FaChevronDown className="w-3 h-3" />
              </>
            )}
          </button>
        </div>

        {issues.map((issue) => (
          <EditableIssue
            key={issue.id}
            issue={issue}
            onUpdate={onUpdateIssue}
            onDelete={onDeleteIssue}
            forceEditMode={allExpanded}
          />
        ))}
      </div>
    </div>
  );
};

export default EditableIssueList;
